import { hasPermission } from './permission';

const sectionRedirectMap = [
  { section: 'dashboard', keys: ['dashboard_view'], path: '/hs/dashboard' },
  { section: 'construction companies', keys: ["cc_view", "cc_manage"], path: '/hs/c-companies'},
  { section: 'truck companies', keys: ["tc_view", "tc_manage"], path: '/hs/t-companies'},
  { section: 'jobs', keys: ['jobs_view'], path: '/hs/jobs' },
  { section: 'cc invoices', keys: ["ccinvoices_view"], path: '/hs/cc-invoices' },
  { section: 'tc invoices', keys: ["tcinvoices_view", "tcinvoices_update"], path: '/hs/tc-invoices' },
  { section: 'supervisors', keys: ['supervisors_view', 'supervisors_edit'], path: '/hs/supervisors' },
  { section: 'site users', keys: ['siteusers_view', 'siteusers_edit'], path: '/hs/siteusers' },
  { section: 'notifications', keys: ['notifications_view','notifications_manage'], path: '/hs/notifications' },
  { section: "reports", keys: ["job_summary_view", "invoice_summary_view"], path: '/hs/reports' },
  { section: 'settings', keys: ['settings_view', 'settings_edit_roles', 'settings_edit_settings'], path: '/hs/settings' },
];

export const getFirstPermittedRoute = () => {
  for (const item of sectionRedirectMap) {
    if (hasPermission({ section: item.section, keys: item.keys })) {
      return item.path;
    }
  }

  console.error("No first permission route found for this user.");
  return null;
};
